import React from 'react'
import { number } from 'prop-types'

import styles from './index.module.css'

export default function ProgressBar(props) {
  const { current, total } = props
  const percent = (current / total) * 100
  return (
    <div className={styles.cntr}>
      <div className={styles.bar} style={{ width: percent + '%' }}></div>
    </div>
  )
}

ProgressBar.propTypes = {
  current: number.isRequired,
  total: number.isRequired
}
